<template>
  <Submenu :name="`${parentName}`">
    <template slot="title">
      <Icon :type="parentItem.icon" />
      <span>{{ showTitle(parentItem) }}</span>
    </template>

    <template v-for="item in children">
      <!-- 区分菜单拥有子级并且只有一个 -->
      <template v-if="item.children && item.children.length === 1">
        <sider-menu-item
          v-if="showChildren(item)"
          :key="`menu-${item.name}`"
          :parent-item="item"
        ></sider-menu-item>
        <menu-item
          v-else
          :name="getNameOrHref(item, true)"
          :key="`menu-${item.children[0].name}`"
        >
          <Icon :type="item.children[0].icon || ''" />
          <span>{{ showTitle(item.children[0]) }}</span>
        </menu-item>
      </template>
      <template v-else>
        <sider-menu-item
          v-if="showChildren(item)"
          :key="`menu-${item.name}`"
          :parent-item="item"
        ></sider-menu-item>
        <menu-item
          v-else
          :name="getNameOrHref(item)"
          :key="`menu-${item.name}`"
        >
          <Icon :type="item.icon || ''" />
          <span>{{ showTitle(item) }}</span>
        </menu-item>
      </template>
    </template>
  </Submenu>
</template>

<script>
import mixin from './mixin';

export default {
  name: 'SiderMenuItem',
  mixins: [mixin],
  props: {
    parentItem: {
      type: Object,
      default: () => {},
    },
    theme: String,
    iconSize: Number,
  },
  computed: {
    parentName() {
      return this.parentItem.name;
    },

    children() {
      return this.parentItem.children;
    },
  },
  mounted() {},
};
</script>
